import {MathJax, MathJaxContext} from "better-react-mathjax";
import {isNullOrUndefined} from "../../services/Validator";
import {renderBulletText} from "../../helpers/StringHelper";

export function SystemKnowledgeDefinitionText({knowledgeDefinition}) {
    // Used in SystemQuestionKnowledge to display Knowledge
    // definition text to know by heart

    // BUILD
    if (isNullOrUndefined(knowledgeDefinition))
        return null
    return (
        <MathJaxContext>
            <MathJax inline dynamic>
                <div className={"whitespace-pre-line text-greyLight11 text-[16px] font-medium sm:font-semibold mt-2"}>
                    {renderBulletText(knowledgeDefinition)}
                </div>
            </MathJax>
        </MathJaxContext>
    );
}